import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthenticationNgRxActions } from '@geekbears/gb-ngrx-auth-basic';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private readonly persistentKeys = ['deviceId', 's_common_user'];

  constructor(private store: Store) {}

  /**
   * Safely clears the session-related data from localStorage and NgRx state.
   * Preserves persistent data like deviceId and "Remember Me" email.
   */
  clearSession(): void {
    const keysToKeep = new Set(this.persistentKeys);
    
    // Get all keys currently in localStorage
    const allKeys = Object.keys(localStorage);
    
    // Clear only non-persistent keys
    allKeys.forEach((key) => {
      if (!keysToKeep.has(key)) {
        localStorage.removeItem(key);
      }
    });

    // Dispatch logout action to clear NgRx state and potentially other library-internal states
    this.store.dispatch(AuthenticationNgRxActions.logout());
  }
}
